import {
  ApplyType,
  Currency,
  JobType,
  SalaryPeriod,
  WorkplaceType,
} from "../../redux/reducer/directJobs.types";

type FormOption<T> = { value: T; label: string };

export const MAX_CONTACT_PERSONS = 10;

export const WORKPLACE_TYPE_OPTIONS: FormOption<WorkplaceType>[] = [
  { value: WorkplaceType.NOT_SPECIFIED, label: "Not specified" },
  { value: WorkplaceType.ON_SITE, label: "On-site" },
  { value: WorkplaceType.HYBRID, label: "Hybrid" },
  { value: WorkplaceType.REMOTE, label: "Remote" },
];

export const JOB_TYPE_OPTIONS: FormOption<JobType>[] = [
  { value: JobType.NOT_SPECIFIED, label: "Not specified" },
  { value: JobType.FULL_TIME, label: "Full-time" },
  { value: JobType.PART_TIME, label: "Part-time" },
  { value: JobType.PERMANENT, label: "Permanent" },
  { value: JobType.FIXED_TERM, label: "Fixed-term" },
  { value: JobType.TEMPORARY, label: "Temporary" },
  { value: JobType.INTERNSHIP, label: "Internship" },
  { value: JobType.STUDENT_JOB, label: "Student job" },
  { value: JobType.FREELANCE, label: "Freelance" },
];

export const CURRENCY_OPTIONS: FormOption<Currency>[] = [
  { value: Currency.DKK, label: "DKK" },
  { value: Currency.SEK, label: "SEK" },
  { value: Currency.NOK, label: "NOK" },
  { value: Currency.EUR, label: "EUR" },
];

export const SALARY_PERIOD_OPTIONS: FormOption<SalaryPeriod>[] = [
  { value: SalaryPeriod.MONTH, label: "per month" },
  { value: SalaryPeriod.YEAR, label: "per year" },
  { value: SalaryPeriod.HOUR, label: "per hour" },
];

export const APPLY_TYPE_OPTIONS: (FormOption<ApplyType> & { id: string })[] = [
  { id: "job-apply-type-url", value: ApplyType.URL, label: "Link to a page" },
  { id: "job-apply-type-email", value: ApplyType.EMAIL, label: "By email" },
];
